import React, { useEffect } from "react";
import AuthService from "../../auth/service";
import Callback from "../../components/callback";
import type { WindowLocation } from "@reach/router";

interface Props {
  location: WindowLocation;
}

const CallbackPage: React.FunctionComponent<Props> = ({ location }: Props) => {
  useEffect(() => {
    if (/supportSignUp|supportForgotPassword/.test(location.search)) {
      /**
       * AuthService.authorize() is used to avoid consent errors
       * when working locally
       */
      AuthService.authorize();
      return;
    }

    if (/access_token|id_token|error/.test(location.hash)) {
      AuthService.handleAuthentication();
    }
  }, [location]);

  return <Callback />;
};

export default CallbackPage;
